module.exports = __webpack_public_path__ + "media/word-chop.0c6f7202.mp4";